import { ComponentProps, lazy, Suspense } from 'react';

// leaflet-routing-machine is large, so load the map layer on demand
const MapWithNavigation = lazy(() => import('./MapWithNavigation'));

const LazyMapWithNavigation = (
  props: ComponentProps<typeof MapWithNavigation>,
) => (
  <Suspense fallback={null}>
    <MapWithNavigation {...props} />
  </Suspense>
);

export default LazyMapWithNavigation;
